'use client';

import { c as _c } from "react/compiler-runtime";
import { datadogRum } from '@datadog/browser-rum';
import { TableBody } from '@mui/material';
import { type ReactNode, useEffect, useRef } from 'react';
import { CardPositionProvider } from 'src/features/roundup-filters/CardPositionContext';
import { useCardOrdering } from 'src/features/roundup-filters/store/hooks/useCardOrdering';
import { Loading } from './Loading';
type Props = {
  tableRowsByOfferId: Record<string, ReactNode>;
  allOfferIds: string[];
  summaryTableSequence: string[];
  numberOfOffers: number;
};
export function SummaryTableBody(t0) {
  const $ = _c(12);
  const {
    tableRowsByOfferId,
    allOfferIds,
    summaryTableSequence,
    numberOfOffers
  } = t0;
  const {
    orderedIds,
    isLoading
  } = useCardOrdering(allOfferIds, summaryTableSequence, "summaryTable");
  const firedRef = useRef(false);
  let t1;
  let t2;
  if ($[0] !== isLoading) {
    t1 = () => {
      if (!isLoading && !firedRef.current) {
        datadogRum.addTiming("summary_table_shown");
        firedRef.current = true;
      }
    };
    t2 = [isLoading];
    $[0] = isLoading;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (isLoading) {
    let t3;
    if ($[3] !== numberOfOffers) {
      t3 = <Loading numberOfOffers={numberOfOffers} />;
      $[3] = numberOfOffers;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== orderedIds || $[6] !== tableRowsByOfferId) {
    let t4;
    if ($[8] !== tableRowsByOfferId) {
      t4 = (id, index) => {
        const child = tableRowsByOfferId[id];
        if (!child) {
          console.error(`[SummaryTableBody] No child found for offer id: ${id}`);
          return null;
        }
        return <CardPositionProvider key={id} value={index}>{child}</CardPositionProvider>;
      };
      $[8] = tableRowsByOfferId;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    t3 = orderedIds.map(t4);
    $[5] = orderedIds;
    $[6] = tableRowsByOfferId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <TableBody>{t3}</TableBody>;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}